import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {NavButtons, RightFrame, ModalMain} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';

import {VERIFY_APP, VERIFY_SMS_PHONE} from '../constants';
import {SelectMethodScreen} from '../screens/select-method-screen';
import type {Method} from '../types';

type Props = {
    resetPhoneNumber: () => void;
};

export function SelectMethod(props: Props) {
    const [selectedMethod, setSelectedMethod] = React.useState<Method>('sms');

    props.resetPhoneNumber();

    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>Select a method</ModalHeader>
                <SelectMethodScreen
                    setSelectedMfaMethod={(method: Method) => {
                        setSelectedMethod(method);
                    }}
                    selectedMfaMethod={selectedMethod}
                />
            </ModalMain>

            <NavButtons>
                <React.Fragment>
                    <Link
                        variant='button-primary'
                        size='big'
                        // @ts-expect-error
                        as={RoutedLink}
                        to={selectedMethod === 'app' ? VERIFY_APP : VERIFY_SMS_PHONE}
                    >
                        Next
                    </Link>
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
